import React from "react";
import "../styles/SobreNosotros.css";

const SobreNosotros = ({ mostrarExpertos, traducciones }) => {
  const handleMostrarExpertos = () => {
    window.scrollTo({ top: 0, behavior: "smooth" }); // Desplaza la página hacia arriba
    mostrarExpertos(); // Llama a la función para mostrar los expertos
  };

  return (
    <div id="sobre-nosotros" className="sobre-container py-5">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 col-md-12 recuadro-transparente">
            {/* Título */}
            <h2 className="titulo-sobre text-start">
              {traducciones.sobre
                ? traducciones.sobre.titulo
                : "SOBRE NOSOTROS"}
            </h2>

            {/* Detalles */}
            <div
              className="detalles-sobre text-start"
              dangerouslySetInnerHTML={{
                __html: traducciones.sobre ? traducciones.sobre.texto : "",
              }}
            ></div>

            {/* Botón */}
            <div className="mt-4">
              <button
                className="btn sobre-button"
                onClick={handleMostrarExpertos}
              >
                {traducciones.sobre
                  ? traducciones.sobre.boton
                  : "Nuestros expertos"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SobreNosotros;